(function () {
  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function init(root) {
    if (!root || root.getAttribute('data-sp-acc-ready') === 'true') return;
    root.setAttribute('data-sp-acc-ready', 'true');

    var items = toArray(root.querySelectorAll('[data-sp-acc-item]'));
    var single = root.getAttribute('data-single') === 'true';
    if (!single || items.length === 0) return;

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function boot() {
    toArray(document.querySelectorAll('[data-sp-acc]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    toArray(event.target.querySelectorAll('[data-sp-acc]')).forEach(function (el) {
      el.removeAttribute('data-sp-acc-ready');
      init(el);
    });
  });
})();
